import {Grid} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import logo from "../../assets/images/logo.png";
import React from "react";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles(theme => ({
    footer: {
        margin: 0,
        width: '100%',
        flexGrow: 1,
        display: 'flex',
        justifyContent: 'space-between',
        height: '15mm',
        paddingLeft: '10mm',
        paddingRight: '10mm',
        flexDirection: 'row',

        flexWrap: 'nowrap',
        borderTop: 1,
        borderTopStyle: 'solid',
        borderTopColor: 'black'

    },
    gridEsq: {
        padding: '5mm',
        width: '50mm',
        flexGrow: 0,
    },
    gridMeio: {
        display: 'flex',
        width: '100%',

        flexGrow: 1,
        alignItems: 'center'

    },
    gridDir: {
        display: 'flex',
        flexGrow: 0,
        alignItems: 'center',
        width: '15mm',

    },


}));

const PageHeader = (props) => {
   const {pagina, meio } = props;
   const classes = useStyles();

    return (
        <Grid container id={'pageFooter'} className={classes.footer}>

                <Grid container item className={classes.gridEsq}>
                    <Typography>www.lukatec.com.br</Typography>
                </Grid>
                <Grid container item className={classes.gridMeio}>
                    <Typography variant={"caption"}>{meio}</Typography>
                </Grid>
                <Grid container item className={classes.gridDir}>
                    <Typography>{pagina}</Typography>
                </Grid>

        </Grid>
    );

}

export default (PageHeader)